import React from "react";
import { HistoryContextProvider } from "../context/HistoryContextProvider";
import { Routes, Route } from "react-router-dom";
import HistoryPage from "../components/History";
import LobbyResultsPage from "../components/LobbyResultsPage";

export default function HistoryRoutes() {
  return (
    <HistoryContextProvider>
      <Routes>
        <Route index element={<HistoryPage />} />
        <Route path="/:lobbyId" element={<LobbyResultsPage />} />
      </Routes>
    </HistoryContextProvider>
  );
}
